import { getApi, postApi, patchApi, deleteApi } from "./apiService";

// 📌 Create a new class
export const createClass = async (classData) => {
    return await postApi("/mp/class/create", classData);
};

// 📌 Update an existing class
export const updateClass = async (classData) => {
    return await patchApi("/mp/class/update", classData);
};
export const updateAttendance = async (classData) => {
    return await patchApi("/mp/class/update-attendance", classData);
};

// 📌 Get class by ID
export const getClassById = async (id) => {
    return await getApi(`/mp/class/get/${id}`);
};

// 📌 Delete a class by ID
export const deleteClassById = async (id) => {
    return await deleteApi(`/mp/class/delete/${id}`);
};

// 📌 Get classes by filter
export const getClassesByFilter = async (queryParams = "") => {
    return await getApi(`/mp/class/get-by-filter${queryParams}`);
};

// 📌 Get class bookings by filter
export const getClassBookingsByFilter = async (queryParams = "") => {
    return await getApi(`/mp/class/get-class-booking-by-filter${queryParams}`);
};

// 📌 Get class booking detail by ID
export const getClassBookingDetail = async (id) => {
    return await getApi(`/mp/class/get-class-booking-detail/${id}`);
};
// 📌 Get class Types
export const getClassTypes = async (id) => {
    return await getApi(`/mp/class/get-class-types`);
};
